import DefaultImageCta from './Default'
import AltImageCta from './Alt'

export default DefaultImageCta

export { AltImageCta }
